import React from "react";

export default function SvgCloseIcon() {
  return <svg viewBox="0 0 12 12">
    <path d="M.257 11.743a.778.778 0 0 0 .6.257.778.778 0 0 0 .6-.257L6 7.2l4.543 4.543a.926.926 0 0 0 .6.257.926.926 0 0 0 .6-.257.829.829 0 0 0 0-1.2L7.2 6l4.543-4.543a.829.829 0 0 0 0-1.2.829.829 0 0 0-1.2 0L6 4.8 1.457.257a.829.829 0 0 0-1.2 0 .829.829 0 0 0 0 1.2L4.8 6 .257 10.543a.829.829 0 0 0 0 1.2z" fill="#fff"/>
  </svg>;
}